import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from 'shared/components';
import { AppointmentsFetchPendingPlaceholder } from 'modules/queues/common/components/AppointmentsList/placeholders';

import theme from './ModalAppointmentForwardingConsent.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  consentData: PropTypes.shape({
    isPending: PropTypes.bool,
    consentDialogMessage: PropTypes.string,
    declineMessage: PropTypes.string,
  }),
  isMobile: PropTypes.bool.isRequired,
};

const defaultProps = {
  consentData: {},
};

const ModalAppointmentForwardingConsent = ({
  intl,
  onOk,
  onCancel,
  consentData,
  isMobile,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <span className={ theme.message }>
        <FormattedMessage id="PatientApp.FutureAppointmentConsentDialog.Title" defaultMessage="** Bring appointment forward" />
      </span>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <Choose>
      <When condition={ !consentData.isPending }>
        <div className={ theme.main }>
          { consentData.consentDialogMessage }
        </div>
      </When>
      <Otherwise>
        <AppointmentsFetchPendingPlaceholder className={ theme.loader } />
      </Otherwise>
    </Choose>

    <div className={ theme.footer }>
      <Button
        testId="modal-appointment-consent-dismiss-button"
        buttonType="naked"
        label={ intl.formatMessage({
          id: 'PatientApp.FutureAppointmentConsentDialog.DeclineButton.Label',
          defaultMessage: '** Keep original schedule',
        }) }
        ariaLabel={ intl.formatMessage({
          id: 'PatientApp.FutureAppointmentConsentDialog.DeclineButton.Label',
          defaultMessage: '** Keep original schedule',
        }) }
        className={ theme.cancelButton }
        labelColor="blackMedium"
        onClick={ onCancel }
        iconPositionLeft
        size={ isMobile ? 'small' : 'medium' }
      />

      <Button
        testId="modal-appointment-consent-agree-button"
        label={ intl.formatMessage({
          id: 'PatientApp.FutureAppointmentConsentDialog.AgreeButton.Label',
          defaultMessage: '** Go to waiting room',
        }) }
        ariaLabel={ intl.formatMessage({
          id: 'PatientApp.FutureAppointmentConsentDialog.AgreeButton.Label',
          defaultMessage: '** Go to waiting room',
        }) }
        iconName="check"
        onClick={ onOk }
        iconPositionRtlNotReversed
        iconDontFlipOnRtl
        iconPositionLeft
        background="green"
        size={ isMobile ? 'small' : 'medium' }
      />
    </div>
  </div>
);

ModalAppointmentForwardingConsent.propTypes = propTypes;
ModalAppointmentForwardingConsent.defaultProps = defaultProps;

export default ModalAppointmentForwardingConsent;
